import * as echarts from 'echarts';
export default {
  name: "dataShow",
  data() {
    return {
      chart: null,
      // 初始化图表实例
      chart0: null,
      // 初始化饼图表实例
      chart1: null,
      // 初始化仪表图表实例
      chart2: null // 初始化图表实例
    };
  },

  mounted() {
    this.initChart();
  },
  // created() {
  //     this.initChart();
  // },
  methods: {
    initChart() {
      if (this.chart) {
        this.chart.dispose(); // 清除已有的echarts实例
      }

      if (this.chart0) {
        this.chart0.dispose(); // 清除已有的echarts实例
      }

      if (this.chart1) {
        this.chart1.dispose(); // 清除已有的echarts实例
      }

      if (this.chart2) {
        this.chart2.dispose(); // 清除已有的echarts实例
      }
      //盛装图表的盒子
      var chartDom = document.getElementById('chart');
      // 删除_echarts_instance_属性
      // chartDom.removeAttribute("_echarts_instance_");
      var myChart = echarts.init(chartDom);
      // 初始化图表实例
      // this.chart = echarts.init(this.$refs.chart);
      this.chart = myChart;
      // 指定图表的配置项和数据
      let option = {
        title: {
          text: '检测电梯数量排名'
        },
        tooltip: {},
        xAxis: {
          data: ["王龙", "张开", "李旭", "张兴", "汪亮", "梁才"]
        },
        yAxis: {
          // data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
        },
        series: [{
          name: '检测数量',
          type: 'bar',
          data: [15, 20, 28, 33, 42, 50]
        }]
      };
      // 使用刚指定的配置项和数据显示图表
      this.chart.setOption(option);
      let option0 = {
        title: {
          text: '不同状态检测数',
          subtext: '检测数',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [{
          name: '不同状态检测数',
          type: 'pie',
          radius: '50%',
          data: [{
            value: 1048,
            name: '检测中'
          }, {
            value: 735,
            name: '上传'
          }, {
            value: 580,
            name: '批准'
          }, {
            value: 484,
            name: '审核'
          }, {
            value: 300,
            name: '编制'
          }],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      this.chart0 = echarts.init(this.$refs.chart0);
      this.chart0.setOption(option0);
      let option1 = {
        title: {
          text: '审批报告数量变化'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['张浩', '李涛']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '张浩',
          type: 'line',
          stack: 'Total',
          data: [120, 132, 101, 134, 90, 230, 210]
        }, {
          name: '李涛',
          type: 'line',
          stack: 'Total',
          data: [220, 182, 191, 234, 290, 330, 310]
        }]
      };
      this.chart1 = echarts.init(this.$refs.chart1);
      this.chart1.setOption(option1);
      let option2 = {
        title: {
          text: '不同时间段的审批数量',
          subtext: '审批数量',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [{
          name: '审批数量',
          type: 'pie',
          radius: '50%',
          data: [{
            value: 248,
            name: '一月'
          }, {
            value: 235,
            name: '二月'
          }, {
            value: 280,
            name: '三月'
          }, {
            value: 284,
            name: '四月'
          }, {
            value: 230,
            name: '五月'
          }, {
            value: 313,
            name: '六月'
          }, {
            value: 256,
            name: '七月'
          }, {
            value: 179,
            name: '八月'
          }, {
            value: 255,
            name: '九月'
          }, {
            value: 247,
            name: '十月'
          }, {
            value: 266,
            name: '十一月'
          }, {
            value: 230,
            name: '十二月'
          }],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      this.chart2 = echarts.init(this.$refs.chart2);
      this.chart2.setOption(option2);
    }
  },
  beforeUnmount() {
    // 组件销毁前，确保销毁图表实例
    if (this.chart) {
      this.chart.dispose();
    }
    if (this.chart0) {
      this.chart0.dispose();
    }
    if (this.chart1) {
      this.chart1.dispose();
    }
    if (this.chart2) {
      this.chart2.dispose();
    }
  }
};